import initializingSmartScript from './initializingSmartScript.js';
import { staticLink } from './constants.js';

export default function setAppLink() {
    const result = initializingSmartScript(staticLink);
    let result_url = "No output from script"; 

    if (result) {
        result_url = result.clickURL;     
        const buttons = document.querySelectorAll(".js-button-download");

        buttons.forEach(button => {
            button.setAttribute('href', result_url);
        });
    } 
}


// WEBPACK FOOTER //
// ./_layout/js/setAppLink.js